import { render, staticRenderFns } from "./PgHistory.vue?vue&type=template&id=1e12eda4&scoped=true&"
import script from "./PgHistory.vue?vue&type=script&lang=js&"
export * from "./PgHistory.vue?vue&type=script&lang=js&"
import style0 from "./PgHistory.vue?vue&type=style&index=0&id=1e12eda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12eda4",
  null
  
)

export default component.exports